import { FetchTasksPriceSortTypes } from './tasksPriceTypes';

export const INITIAL_TASKS_PRICE_FILTERS = {};
export const INITIAL_TASKS_PRICE_PAGE = 1;
export const INITIAL_TASKS_PRICE_SORT = [
  FetchTasksPriceSortTypes.SMART_CONTRACT_LAST_STATUS_CHANGE_AT_DESC
];
export const INITIAL_TASKS_PRICE_LIMIT = 100;
